/**
 * @author Team CMS
 *
 * Custom event target class to be used in node environment
 * @class CustomEventTarget
 * @implements {EventTarget}
 */
class CustomEventTarget {
  private readonly listeners: Map<string, Set<EventListener>> = new Map();

  addEventListener(type: string, listener: EventListener): void {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, new Set());
    }
    this.listeners.get(type)?.add(listener);
  }

  removeEventListener(type: string, listener: EventListener): void {
    this.listeners.get(type)?.delete(listener);
  }

  dispatchEvent(event: Event): boolean {
    const listeners = this.listeners.get(event.type);
    listeners?.forEach((listener) => listener(event));
    return true;
  }
}

const eventNotifier = typeof window !== 'undefined' ? new EventTarget() : new CustomEventTarget();

export { eventNotifier };
